// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import ModifiedDropdown from '@wandb/weave/common/components/elements/ModifiedDropdown';
import React from 'react';

import {useProjectTagsQuery} from '../../../state/graphql/projectTagsQuery';
import type * as FilterTypes from '../../../util/filterTypes';
import type * as RunTypes from '../../../util/runTypes';
import {filterValueOptionTransform} from '../../Filters/FilterValueSelector';

interface RunsFilterTagNameSelectorProps {
  entityName: string;
  projectName: string;
  filter: FilterTypes.IndividualFilter<RunTypes.Key>;
  setFilter(filter: Partial<FilterTypes.IndividualFilter<RunTypes.Key>>): void;
}

export const RunsFilterTagNameSelector = ({
  entityName,
  filter,
  projectName,
  setFilter,
}: RunsFilterTagNameSelectorProps) => {
  const projectTagsQuery = useProjectTagsQuery({entityName, projectName});
  const tagCounts =
    !projectTagsQuery.loading || !projectTagsQuery.data?.project.tagCounts
      ? []
      : projectTagsQuery.data?.project.tagCounts;
  const suggestions = tagCounts.map(tc => ({
    key: tc.name,
    value: tc.name,
    text: tc.name,
    count: tc.count,
  }));
  const tagNames = tagCounts.map(tc => tc.name);
  let currentValue: any;
  const isMulti = filter.op === 'IN' || filter.op === 'NIN';
  if (isMulti) {
    currentValue = filter.value;
    for (const name of currentValue) {
      if (!tagNames.includes(name)) {
        tagNames.push(name);
      }
    }
  } else {
    currentValue = filter.key.name;
    const valueTagName = filter.key.name;
    if (!tagNames.includes(valueTagName)) {
      tagNames.push(valueTagName);
    }
  }
  return (
    <ModifiedDropdown
      className="filter-dropdown filter-list__value"
      // With current optimizations, some components do not update on function prop changes.
      // To avoid a stale filter callback, we include an empty style prop to force a re-render.
      // (This is a workaround, not the ideal solution)
      // Refer to shouldUpdate.ts : L16
      style={{}}
      options={suggestions}
      optionTransform={filterValueOptionTransform}
      loading={projectTagsQuery.loading}
      placeholder="value"
      search
      multiple={isMulti}
      inline
      value={currentValue}
      onChange={(e, {value}) => {
        const f = filter;
        if (isMulti) {
          setFilter({
            ...f,
            value,
            disabled: false,
          } as FilterTypes.IndividualFilter<RunTypes.Key>);
        } else {
          setFilter({
            ...f,
            key: {section: 'tags', name: value as string},
            disabled: false,
          });
        }
      }}
    />
  );
};
